import React, { useState, useEffect, useContext } from 'react';
import {
  Card,
  CardContent,
  List,
  ListItem,
  Snackbar,
  Tooltip,
  Typography,
  Button
} from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import InsertLinkIcon from '@material-ui/icons/InsertLink';
import { Alert, Skeleton } from '@material-ui/lab';
import { InsertDriveFile } from '@material-ui/icons';
import config from '../../utils/config';
import {  downloadFile } from '../../utils/downloadFiles';
import { get } from '../../utils/network';
import DownloadButton from './DownloadFileButton'
import FileModal from './FileModal'
import { DocumentTypesContext } from './DocumentTypesContext'


const useStyles = makeStyles(theme => ({
  modal: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
  paper: {
    backgroundColor: 'black',
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

Array.prototype.contains = function(element){
  return this.indexOf(element) > -1;
};

const STYLE_WHITESPACE = '0.75rem'
const ALLOW_THUMBNAIL = ['jpg', 'jpeg', 'png', 'gif']

const ImageCard = ({ result, docType, style }) => {
  const { metadata, image, name, url, type, extension, nombre_archivo, identifier, identifier_field : document_identifier_field } = result;
  // const documentTypesInfo = useDocumentTypes();
  const documentTypesInfo = useContext(DocumentTypesContext).find(documentType => documentType.documentType == type);
  const fileSource = `documents/${nombre_archivo}/rawfile`
  const absoluteFileSource = `${config.frontEndUrl}#/documents/${nombre_archivo}/rawfile`
  const documentType = docType.find(d => d.documentType == type) ? docType.find(d => d.documentType == type) : {}
  const docTypeSchema = documentType.schema != undefined ? JSON.parse(documentType.schema) : undefined// Problema
  const identifier_field = documentType.schema != undefined ? docTypeSchema.properties[documentTypesInfo.identifier] : undefined

  const filteredMetadata = metadata
    .filter((data) => {
      if(docTypeSchema != undefined){
        // Include metadata in card if:
        return documentType != undefined || (                            // All metadata if undefined
          docTypeSchema.properties[data.name] != undefined &&     // Its included in schema
          docTypeSchema.properties[data.name].hidden != true &&   // Its not hidden
          data.name != 'type' &&                                  // Its not the type metadata
          data.name != document_identifier_field                  // Its not the identifier metadata
        )
      }
    })
    .slice(0, 8)                                              // Only the first 9 metadata

  const [fileUrl, setFileUrl] = useState('');
  const fetchImage = async () => {
    try {
      const response = await get(fileSource);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      setFileUrl(url);
    } catch (error) {
      console.error('Failed to fetch image', error);
    }
  };

  useEffect(() => {
    if(ALLOW_THUMBNAIL.contains(extension)){
      fetchImage();
    }

    // Cleanup
    return () => fileUrl && window.URL.revokeObjectURL(fileUrl);
  }, []); 

  const classes = useStyles();
  const [snackBarOpen, SetSnackbBarOpen] = useState(false);
  const handleSnackClose = () => {
    SetSnackbBarOpen(false);
  };
  const handleSnackOpen = () => {
    navigator.clipboard.writeText(absoluteFileSource);
    SetSnackbBarOpen(true);
  };

  const [loadingImage, setLoadingImage] = useState(true);

  const handleImageLoad = () => setLoadingImage(false);

  const [modalOpen, SetModalOpen] = useState(false);
  const handleCloseModal = () => SetModalOpen(false);
  const handleOpenModal = () => {
    fetchImage();
    SetModalOpen(true);
  }

 

  return (
    <div style={{ flexGrow: 1 }}>
      <>
        <Modal className={classes.modal} open={modalOpen} onClose={handleCloseModal}>
          <div>
            <FileModal onClose={handleCloseModal} metadata={metadata} name={name} fileType={extension} fileUrl={fileUrl} uploadedBy={result.uploaded_by} uploadDate={result.upload_date} fullName={result.user_full_name}/>
          </div>
        </Modal>
        <Snackbar
          autoHideDuration={4000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          open={snackBarOpen}
          onClose={handleSnackClose}
        >
          <Alert icon={<InsertLinkIcon />} severity="info">
            Link copiado
          </Alert>
        </Snackbar>

        <Card style={{ borderRadius: '0.5rem', ...style }}>
          <CardContent style={{ 
            display: 'grid', 
            gridTemplateColumns: '210px 1fr',
            gridTemplateRows: 'fit-content(2rem)', 
            gap: STYLE_WHITESPACE, 
            margin: STYLE_WHITESPACE, 
            flexFlow: 'row' 
          }}>
            <div style={{borderRadius: '0.5rem', overflow:'hidden'}}>
              { !ALLOW_THUMBNAIL.contains(extension) ? // Check if is allowed thumbnail or not
                <div style={{
                    width: '100%', 
                    height: '100%',
                    padding: 0,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '1px solid #efefef',
                    borderRadius: STYLE_WHITESPACE
                  }}>
                    <div style={{
                      border: '2px solid #000',
                      borderRadius: '0.25rem',
                      padding: '0.25rem',
                      textTransform: 'uppercase',
                      fontSize: '0.75rem',
                      position: 'absolute',
                      backgroundColor:"white",
                      transform: 'translate(1rem, 1.30rem)'
                    }}>{extension}</div>
                    <InsertDriveFile style={{fontSize: '4rem'}}></InsertDriveFile>
                </div> : 
                <>
                  <img
                    alt="document"
                    onLoad={handleImageLoad}  //TODO: Find a better way to load image
                    style={{
                      display: 'none',
                      animation: 'fadeIn 0.5s',
                      width: '0', 
                      height: '0',
                    }}
                    src={fileUrl}
                  />
                  <div style={{
                    animation: 'fadeIn 0.5s',
                    display: loadingImage ? 'none' : 'block',
                    backgroundImage: `url(${fileUrl})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    width: '100%', 
                    height: '100%'
                  }}/>
                  {loadingImage ? <Skeleton variant="rect" width="100%" height="100%" /> : <></>}
                </>
              }
            </div>
            <div style={{ display: 'flex', flexDirection:'column', alignItems:'center', alignItems: 'flex-end'}}>
              <div
                style={{
                  display: 'grid', 
                  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', 
                  gap: STYLE_WHITESPACE,
                  width: '100%'
                }}
              >
                  <div>
                    {documentTypesInfo && (
                      <div style={{display:'flex', flexDirection:'column'}}> 
                        <span style={{fontSize: '0.75rem', lineHeight: '1rem', color: '#1d558c'}}>Tipo de documento</span> 
                        <span style={{ color: 'grey', fontSize: '1.25rem', fontWeight:'bold', lineHeight: '1.25rem', color: '#1d558c' }}>{documentTypesInfo.description}</span>
                      </div>
                    )}
                  </div>
                  <div>
                    {(documentTypesInfo && identifier_field != undefined)  && (
                      <div style={{display:'flex', flexDirection:'column'}}> 
                        <span style={{fontSize: '0.75rem', lineHeight: '1rem', color: '#1d558c'}}>{identifier_field.label}</span> 
                        <span style={{ color: 'grey', fontSize: '1.25rem', fontWeight:'bold', lineHeight: '1.25rem', color: '#1d558c' }}>{identifier}</span>
                      </div>
                    )}
                  </div>
                  <div style={{justifySelf: 'end'}}>
                    <DownloadButton name={name}/>

                    <Tooltip href={absoluteFileSource} target="_blank" title="Abrir en nueva ventana">
                      <IconButton>
                        <OpenInNewIcon />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Copiar link">
                      <IconButton onClick={handleSnackOpen}>
                        <InsertLinkIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                  {filteredMetadata && 
                      filteredMetadata.map((data, j) => {
                          return (
                            <div key={j} style={{ }}>
                              <span style={{display:'block', fontSize: '0.75rem', lineHeight:'0.5rem', color: '#606668'}}>{data.label}</span>
                              <span style={{display:'block', fontWeight:'bold', color: '#606668', wordWrap: 'break-word'}}>{data.value}</span>
                            </div>
                          )
                          }
                        )
                    }
              </div>
              <Button size="small" variant="outlined" onClick={handleOpenModal} style={{backgroundColor: '#25265d', color:'white', marginTop: '0.75rem'}}>Mostrar mas ...</Button>
            </div>
            
            
          </CardContent>
        </Card>
      </>
    </div>
  );
};

export default ImageCard;